// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green-row {
    background-color: #f6ffed !important;
}

.dark-modal .green-row {
    background-color: #162312 !important;
}

/* Eğitimler */
.egitimler-table .ant-table-thead > tr > th {
    background-color: #08335e !important;
    color: white !important;
    text-align: center !important;
    font-size: 14px !important;
}

.egitimler-table .ant-table-tbody > tr > td {
    text-align: center !important;
    font-size: 14px !important;
}

.dark-modal .egitimler-table .ant-table-thead > tr > th {
    background-color: #08335e !important;
    color: white !important;
}

/* Personel fotoğrafı (03.11.2026) */
.pf-avatar {
    position: relative;
    display: inline-block;
    margin-bottom: 16px;
}

.pf-avatar .profil-avatar {
    margin-bottom: 0;
}

.pf-degistir.ant-btn {
    position: absolute;
    right: 8%;
    bottom: 8%;
    width: 40px;
    height: 40px;
    border: 3px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.profil-container.dark .pf-degistir.ant-btn {
    border-color: #141414;
}

.pf-kirp {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding-top: 6px;
}

.pf-cerceve {
    position: relative;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 10px;
    background: #f0f0f0;
    cursor: grab;
    touch-action: none;
    -webkit-user-select: none;
            user-select: none;
}

.pf-cerceve:active {
    cursor: grabbing;
}

.pf-cerceve img {
    position: absolute;
    top: 0;
    left: 0;
    max-width: none;
    pointer-events: none;
}

.pf-daire {
    position: absolute;
    left: 0;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.45);
    pointer-events: none;
}

.pf-yakinlik {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 280px;
    max-width: 100%;
}

.pf-yakinlik .ant-slider {
    flex: 1 1;
}

.pf-ipucu {
    font-size: 12px;
    text-align: center;
}

@media (max-width: 768px) {
    .pf-degistir.ant-btn {
        width: 30px;
        height: 30px;
        min-width: 30px;
        border-width: 2px;
        right: 0;
        bottom: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ik/Personel.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,cAAc;AACd;IACI,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,kBAAkB;IAClB,0CAA0C;IAC1C,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,QAAQ;QACR,SAAS;IACb;AACJ","sourcesContent":[".green-row {\n    background-color: #f6ffed !important;\n}\n\n.dark-modal .green-row {\n    background-color: #162312 !important;\n}\n\n/* Eğitimler */\n.egitimler-table .ant-table-thead > tr > th {\n    background-color: #08335e !important;\n    color: white !important;\n    text-align: center !important;\n    font-size: 14px !important;\n}\n\n.egitimler-table .ant-table-tbody > tr > td {\n    text-align: center !important;\n    font-size: 14px !important;\n}\n\n.dark-modal .egitimler-table .ant-table-thead > tr > th {\n    background-color: #08335e !important;\n    color: white !important;\n}\n\n/* Personel fotoğrafı (03.11.2026) */\n.pf-avatar {\n    position: relative;\n    display: inline-block;\n    margin-bottom: 16px;\n}\n\n.pf-avatar .profil-avatar {\n    margin-bottom: 0;\n}\n\n.pf-degistir.ant-btn {\n    position: absolute;\n    right: 8%;\n    bottom: 8%;\n    width: 40px;\n    height: 40px;\n    border: 3px solid #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n.profil-container.dark .pf-degistir.ant-btn {\n    border-color: #141414;\n}\n\n.pf-kirp {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 14px;\n    padding-top: 6px;\n}\n\n.pf-cerceve {\n    position: relative;\n    flex-shrink: 0;\n    overflow: hidden;\n    border-radius: 10px;\n    background: #f0f0f0;\n    cursor: grab;\n    touch-action: none;\n    user-select: none;\n}\n\n.pf-cerceve:active {\n    cursor: grabbing;\n}\n\n.pf-cerceve img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: none;\n    pointer-events: none;\n}\n\n.pf-daire {\n    position: absolute;\n    left: 0;\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.9);\n    box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.45);\n    pointer-events: none;\n}\n\n.pf-yakinlik {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 280px;\n    max-width: 100%;\n}\n\n.pf-yakinlik .ant-slider {\n    flex: 1;\n}\n\n.pf-ipucu {\n    font-size: 12px;\n    text-align: center;\n}\n\n@media (max-width: 768px) {\n    .pf-degistir.ant-btn {\n        width: 30px;\n        height: 30px;\n        min-width: 30px;\n        border-width: 2px;\n        right: 0;\n        bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
